export const contact = {
  email: 'chris@gomagen.com',
  phone: '+1-506-869-0897',
  phoneHref: 'tel:+15068690897',
  location: 'Moncton, New Brunswick',
  region: 'Atlantic Canada',
};

export const services = [
  {
    id: 'electronics',
    icon: 'chip',
    title: 'Electronics & Embedded Systems',
    summary:
      'Custom circuit boards and the firmware that runs on them, taken from schematic to a working board on your bench.',
    details: [
      'Schematic capture and PCB layout',
      'Microcontroller and embedded Linux firmware',
      'Low-voltage sensor and battery-powered circuit design',
      'Bring-up, debugging and test fixtures',
    ],
  },
  {
    id: 'iot',
    icon: 'signal',
    title: 'IoT & Connected Devices',
    summary:
      'Devices that report back reliably. We connect hardware to the cloud securely and make fleets manageable.',
    details: [
      'Wi-Fi, BLE, LoRaWAN and cellular connectivity',
      'MQTT and HTTP telemetry pipelines',
      'Over-the-air updates and device provisioning',
      'Dashboards, alerting and remote monitoring',
    ],
  },
  {
    id: 'ai',
    icon: 'spark',
    title: 'AI Consulting & Implementation',
    summary:
      'Practical AI for small and medium businesses. We find where AI will save you time, then build it into the tools and workflows you already use.',
    details: [
      'AI readiness assessments and roadmaps',
      'Assistants and chatbots that answer from your own documents',
      'Workflow automation connected to your existing software',
      'Computer vision and on-device (edge) AI',
      'Staff training and ongoing support',
    ],
  },
  {
    id: 'software',
    icon: 'code',
    title: 'Software, Web & Mobile',
    summary:
      'The apps, APIs and backends that let people use your product: fast, secure and easy to maintain.',
    details: [
      'Web applications and customer portals',
      'iOS and Android companion apps',
      'APIs, databases and cloud infrastructure',
      'Integrations with your existing systems',
    ],
  },
  {
    id: 'prototyping',
    icon: 'cube',
    title: 'Rapid Prototyping',
    summary:
      'Working prototypes built in-house, so you can test real hardware with real users early.',
    details: [
      'Proof-of-concept and feasibility builds',
      'In-house assembly and small production runs',
      '3D-printed enclosures and mechanical fit-up',
      'Design for manufacturing handoff',
    ],
  },
  {
    id: 'strategy',
    icon: 'compass',
    title: 'Technical Strategy & Security',
    summary:
      'Experienced technical advice when you need it: architecture reviews, vendor selection and building security in from the start.',
    details: [
      'Technology roadmaps and feasibility studies',
      'Architecture and code reviews',
      'Security-by-design and threat modelling',
      'Fractional CTO and team support',
    ],
  },
];

export const aiForBusiness = {
  useCases: [
    'Answer customer questions around the clock',
    'Draft quotes, emails and reports in seconds',
    'Pull data out of invoices, forms and PDFs',
    'Search everything your company knows in one place',
    'Summarize meetings, calls and long documents',
    'Spot trends in your sales and operations data',
  ],
  steps: [
    { title: 'Assess', text: 'We review how your team works and find the tasks where AI pays off fastest.' },
    { title: 'Pilot', text: 'We build a small, low-risk trial on your real data so you can see results first.' },
    { title: 'Implement', text: 'We connect what works to your existing systems, with your data kept private and secure.' },
    { title: 'Support', text: 'We train your staff and stay on hand to tune, maintain and expand what we built.' },
  ],
};

export const serviceArea = [
  'Moncton',
  'Dieppe',
  'Riverview',
  'Fredericton',
  'Saint John',
  'Halifax',
  'Charlottetown',
  "St. John's",
];

export const process = [
  {
    step: '01',
    title: 'Discover',
    text: 'We learn your goals, constraints and users, then define what success looks like and what it will take to get there.',
  },
  {
    step: '02',
    title: 'Prototype',
    text: 'We build fast, testable versions of the hardware and software so the riskiest questions are answered early.',
  },
  {
    step: '03',
    title: 'Build',
    text: 'We harden the design with production-grade firmware, software and electronics, built to be tested and maintained.',
  },
  {
    step: '04',
    title: 'Launch & Support',
    text: 'We help with manufacturing, deployment and handoff, and we stay available as your product grows.',
  },
];
